import { Button, ChevronDown, SquaresExclude } from "@repo/ui";
import { TaskPanelItems } from "./task-panel-items";
import { SortBy, type SortType } from "../../task.types";

export const PANEL_BUTTONS = {
  ChangeStatus: "change-status",
  List: "list",
} as const;

export type PanelButton = (typeof PANEL_BUTTONS)[keyof typeof PANEL_BUTTONS];

type Props = {
  sortBy: SortType | undefined;
  sortDirection?: "asc" | "desc";
  activeButtons?: Set<PanelButton>;
  onSortChange: (sort: SortType, direction?: "asc" | "desc") => void;
  onChangeStatusClick?: () => void;
  onListsClick?: () => void;
};

export const TaskPanel = ({
  sortBy,
  sortDirection = "asc",
  activeButtons,
  onSortChange,
  onChangeStatusClick,
  onListsClick,
}: Props) => {
  return (
    <div className="border-gxe-border flex h-12 items-center border-b">
      <TaskPanelItems title="Lists" className="gap-7">
        <Button
          data-allow-navigation
          icon={<ChevronDown className="h-3.5 w-3.5" />}
          variant={activeButtons?.has(PANEL_BUTTONS.List) ? "secondary" : "outline"}
          align="center"
          justify="center"
          size={"icon_xs"}
          onClick={onListsClick}
          className="rounded-sm"
          title={"Select List"}
        />
      </TaskPanelItems>
      <TaskPanelItems title="Sort" className="gap-4">
        <div className="flex gap-2">
          <Button
            data-allow-navigation
            icon={
              <div className="flex items-center gap-0.5">
                <span className="flex h-3.5 w-3.5 items-center justify-center">N</span>
              </div>
            }
            variant={sortBy === SortBy.Name ? "secondary" : "outline"}
            align="center"
            justify="center"
            className="rounded-full"
            size={"icon_md"}
            onClick={() => {
              if (sortBy === SortBy.Name) {
                onSortChange(SortBy.Name, sortDirection === "asc" ? "desc" : "asc");
              } else {
                onSortChange(SortBy.Name, "asc");
              }
            }}
            title="Sort by Name"
          />
          <Button
            data-allow-navigation
            icon={
              <div className="flex items-center gap-0.5">
                <span className="flex h-3.5 w-3.5 items-center justify-center">W</span>
              </div>
            }
            variant={sortBy === SortBy.Workflow ? "secondary" : "outline"}
            align="center"
            justify="center"
            size={"icon_md"}
            className="rounded-full"
            onClick={() => {
              if (sortBy === SortBy.Workflow) {
                onSortChange(SortBy.Workflow, sortDirection === "asc" ? "desc" : "asc");
              } else {
                onSortChange(SortBy.Workflow, "asc");
              }
            }}
            title="Sort by Workflow (Active Fields)"
          />
        </div>
      </TaskPanelItems>
      <TaskPanelItems className="h-full w-full" />
      <TaskPanelItems className="border-0">
        <Button
          data-allow-navigation
          icon={<SquaresExclude className="h-4 w-4" />}
          variant={activeButtons?.has(PANEL_BUTTONS.ChangeStatus) ? "secondary" : "outline"}
          align="center"
          justify="center"
          size={"icon_md"}
          className="rounded-full"
          title="Change workflow status"
          onClick={onChangeStatusClick}
        />
      </TaskPanelItems>
    </div>
  );
};
